
import { defineComponent } from 'vue'
import axios from 'axios'

export default defineComponent({
  name: 'TeamContent',
  data () {
    return {
      userLocation: []
    }
  },
  methods: {
    async fetchUserLocation () {
      return new Promise<void>((resolve) => {
        axios.get('/api/user/location-list/').then(response => {
          this.userLocation = response.data
          resolve()
        })
      })
    },
  },
  mounted () {
    this.fetchUserLocation()
  }
})
